import { Component } from "react";
import EmbedPopupViewport from "./embedPopupViewport";

// Organisation details mount only while open; venue details stay mounted.
// Keep subscriptions, Escape handling, and sizing tied to visibility in both cases.
export default class EmbedGridDetailBase extends Component {
    portalTarget = document.createElement("div");
    viewport = new EmbedPopupViewport(
        region => this.setState({ region }),
        () => this.scrollContent ? this.scrollContent.scrollHeight : window.innerHeight
    );

    componentDidMount() {
        this.portalTarget.className = "embed-detail-portal";
        document.body.appendChild(this.portalTarget);
        if (this.props.open && this.props.data) this.startPopup();
    }

    componentDidUpdate(prevProps) {
        const wasOpen = !!(prevProps.open && prevProps.data);
        const isOpen = !!(this.props.open && this.props.data);
        if (isOpen && !wasOpen) this.startPopup();
        if (!isOpen && wasOpen) this.stopPopup();
    }

    componentWillUnmount() {
        this.portalTarget.remove();
        this.stopPopup();
    }

    startPopup = () => {
        document.addEventListener("keydown", this.onKey);
        this.viewport.start();
    };

    stopPopup = () => {
        document.removeEventListener("keydown", this.onKey);
        this.viewport.stop();
    };

    onKey = event => {
        if (event.key === "Escape" && this.props.open) this.handleClose();
    };

    handleClose = () => {
        this.setState({ bioExpanded: false });
        this.props.onClose();
    };

    getOverlayStyle = () => {
        const region = this.state.region;
        return {
            position: region && region.absolute ? "absolute" : "fixed",
            top: region && region.absolute ? region.top : 0,
            left: 0,
            width: "100%",
            height: region ? region.height : window.innerHeight,
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        };
    };
}
